import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box, Chip, Stack } from '@mui/material';
import { Verified, Spa } from '@mui/icons-material';

export default function ProductCard({ product, children }) {
  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardMedia
        component="img"
        height="140"
        image={product.image_url || '/placeholder-product.png'}
        alt={product.name}
        sx={{ objectFit: 'contain', bgcolor: 'grey.50', p: 1 }}
      />
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" noWrap gutterBottom>
          {product.name}
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          {product.brand}
        </Typography>

        {product.package_size && (
          <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
            {product.package_size}
          </Typography>
        )}

        {product.upc && (
          <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
            UPC: {product.upc}
          </Typography>
        )}

        {/* Certifications */}
        {product.certifications && product.certifications.length > 0 && (
          <Stack direction="row" spacing={0.5} sx={{ mt: 1, flexWrap: 'wrap', gap: 0.5 }}>
            {product.certifications.map((cert) => (
              <Chip
                key={cert}
                label={cert}
                size="small"
                icon={cert === 'organic' ? <Spa /> : undefined}
                variant="outlined"
              />
            ))}
          </Stack>
        )}

        {/* Verified Badge */}
        {product.verified && (
          <Box sx={{ mt: 1 }}>
            <Chip
              icon={<Verified />}
              label="Verified"
              size="small"
              color="primary"
              variant="outlined"
            />
          </Box>
        )}

        {/* Nutrition highlights */}
        {product.nutrition_data && (
          <Box sx={{ mt: 1 }}>
            <Typography variant="caption" color="text.secondary">
              Nutrition info available
            </Typography>
          </Box>
        )}
      </CardContent>

      {/* Action area (passed as children) */}
      {children}
    </Card>
  );
}
